import { Component, OnInit } from '@angular/core';
import { AuthService } from '../_services/auth.service';
import { faSearch, faUser } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.less'],
    standalone: false
})
export class NavbarComponent implements OnInit {

  faSearch = faSearch;
  faUser = faUser;

  constructor(private auth: AuthService) { }

  user: string = "";

  query: string = "";

  queryM: boolean = false;

  expandNav() {
    var col:HTMLDivElement= (<HTMLDivElement>document.getElementById('navbarCollapse'));
    if (col.classList.contains('collapse')) {
      col.classList.remove('collapse');
    } else {
      col.classList.add('collapse');
    }
  }

  ngOnInit() {
    if(this.auth.asCredencials()) {
      this.auth.user().subscribe((data: any) => {
        this.user = data.nome;
      });
    }
  }

  logout() {
    this.user = "";
    this.auth.loggout();
  }

  search() {
    console.log("reached"+this.queryM);
    window.location.href="/produtos?query="+this.query+"&queryM="+this.queryM+"&marca=&type=";
  }


}
